import gql from 'graphql-tag'

export default gql`query phxShifts($pod_id: ID!, $rounding_or_rotation: Boolean) {
	phxShifts(pod_id: $pod_id, rounding_or_rotation: $rounding_or_rotation) {
		id
    name
  }
}`
